import { client } from '../client';
import { getData } from '../apiUtils';
import { Endpoints } from '../endpoints';

export const getAllAccessRoles = async () => client.get(Endpoints.accessRoles).then(getData);
